import {get, isEmpty, isNil} from 'lodash'

export const filterJobCardsByDateRange = (jobCards, targetDatePath, targetStart, targetEnd) => {
  if (isEmpty(jobCards))
    return []

  if (isNil(targetStart) && isNil(targetEnd))
    return jobCards

  return jobCards.filter(jobCard => {
    const targetDate = get(jobCard, targetDatePath, null)
    return (targetDate > targetStart && targetDate < targetEnd) || isNil(targetDate)
  })
}
